import Products from "./products";

const Utils = {
  requiresInsurance(passType) {
    return [
      'passAnnualAdultFull',
      'passAnnualChildFull',
      'passAnnualAdultWeekdays',
      'passAnnualChildWeekdays',
    ].includes(passType)
  },

  useDailyInsurance(passType) {
    return [
      'passHourlyAdult',
      'passHourlyChild',
      'passAnnualAdultAdvantage',
      'passAnnualChildAdvantage'
    ].includes(passType)
  },

  getSkuPrice(productId, skuId, skus) {
    if (!skus) { return false}
    try {
      return skus.find(s => s.id === Products.find(p => p.id === productId)[skuId]).price / 100
    } catch(e) {
      throw new Error("Can't find SKU price", {productId, skuId})
    }
  },

  getProductFrom(productId) {
    return Products.find(p => p.id === productId)
  },

  isWeekday(date, specialWeekends) {
    // Check if selected date is a special weekend
    const isDateWeekend = specialWeekends.filter(d => Utils.datesAreOnSameDay(new Date(d.date), date))
    
    if(isDateWeekend.length > 0) {
      return false
    }
    return ![0, 6].includes(date.getDay())
  },

  skuPrice(product, alternativeKey, skus) {
    return skus.find(sku => sku.id === product[alternativeKey || 'skuId']).price / 100
  },

  skuIdPrice(id, skus) {
    return skus.find(sku => sku.id === id).price / 100
  },

  getPassTypeFrom(skuId) {
    const product = Products.find(p => p.skuId === skuId)
    return product ? product.id : null
  },

  isHourly(passType) {
    return ['passHourlyAdult', 'passHourlyChild'].includes(passType)
  },

  objEmpty(object) {
    return object ? !Object.keys(object).length : true
  },

  validateEmail(email) {
    const emailValue = email || ''
    // eslint-disable-next-line no-useless-escape
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(emailValue.trim()).toLowerCase())
  },

  upgradeSelected(person) {
    return person.membership && person.passType && person.passType !== person.membership.type
  },

  isToday(date) {
    const today = new Date()
    return date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
  },

  datesAreOnSameDay(first, second) {
    return first.getFullYear() === second.getFullYear() &&
      first.getMonth() === second.getMonth() &&
      first.getDate() === second.getDate()
  },

  dateEquivalentInCPH(date) {
    try {
      const equivalentDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes()));
      const utcDate = new Date(equivalentDate.toLocaleString('en-US', { timeZone: "UTC" }))
      const tzDate = new Date(equivalentDate.toLocaleString('en-US', { timeZone: 'Europe/Copenhagen' }));
      const offset = utcDate.getTime() - tzDate.getTime()

      if (!utcDate || !tzDate || !offset) {
        throw new Error("Device does not seem to support required timezone functionality")
      }

      equivalentDate.setTime(equivalentDate.getTime() + offset)
      return equivalentDate
    } catch(error) {
      return date
    }
  },

  attempt(fn, defaultVal) {
    try {
      return fn()
    } catch (e) {
      return defaultVal
    }
  }
}

// Is done this way, because we used to just export default Utils
// - then we started exporting the single functions later
export const {
  isHourly,
  requiresInsurance,
  useDailyInsurance,
  getProductFrom,
  getSkuPrice,
  skuPrice,
  isWeekday,
  skuIdPrice,
  objEmpty,
  getPassTypeFrom,
  dateEquivalentInCPH,
  attempt,
  upgradeSelected
} = Utils

export default Utils